import React, { useEffect, useState } from "react";
import { FieldGroup } from "../../../../components";
import { isEmpty } from "lodash";
import { isMobile } from "react-device-detect";

const DetailInfo = ({ data }) => {
  return (
    <div
      className={`${
        isMobile ? "row" : "border"
      } detail-info  border-gray-200 text-truncate`}
    >
      <div className={`${isMobile ? "col-12 px-1 py-1" : ""}`}>
        <div
          className={`${
            isMobile ? "" : "border-bottom"
          } detail-item border-gray-200 text-truncate`}
        >
          {!isEmpty(data) ? data?.brand : null}&nbsp;
        </div>
      </div>
      <div className={`${isMobile ? "col-6 px-1 py-1" : ""}`}>
        <div
          className={`${
            isMobile ? "" : "border-bottom"
          } detail-item border-gray-200 text-truncate`}
        >
          {!isEmpty(data) ? data?.model : null}&nbsp;
        </div>
      </div>
      <div className={`${isMobile ? "col-6 px-1 py-1" : ""}`}>
        <div
          className={`${
            isMobile ? "" : "border-bottom"
          } detail-item border-gray-200 text-truncate`}
        >
          {!isEmpty(data) ? data?.reference_number : null}&nbsp;
        </div>
      </div>

      <div className={`${isMobile ? "col-6 px-1 py-1" : ""}`}>
        <div
          className={`${
            isMobile ? "" : "border-bottom"
          } detail-item border-gray-200 text-truncate`}
        >
          {!isEmpty(data) ? data?.dial_color : null} &nbsp;
        </div>
      </div>

      <div className={`${isMobile ? "col-6 px-1 py-1" : ""}`}>
        <div
          className={`${
            isMobile ? "" : "border-bottom"
          } detail-item border-gray-200 text-truncate`}
        >
          {!isEmpty(data) ? data?.bracelet_type : null}&nbsp;
        </div>
      </div>

      <div className={`${isMobile ? "col-6 px-1 py-1" : ""}`}>
        <div
          className={`${
            isMobile ? "" : "border-bottom"
          } detail-item border-gray-200 text-truncate`}
        >
          {!isEmpty(data) ? data?.dial_index : null} &nbsp;
        </div>
      </div>

      <div className={`${isMobile ? "col-6 px-1 py-1" : ""}`}>
        <div
          className={`${
            isMobile ? "" : "border-bottom"
          } detail-item border-gray-200 text-truncate`}
        >
          {!isEmpty(data) ? data?.size : null} &nbsp;
        </div>
      </div>
    </div>
  );
};

export default DetailInfo;
